import AfterSalesSummaryBox from './AfterSalesSummaryBox';

export default AfterSalesSummaryBox;
